// Article types + shared constants. Data now comes from the backend API
// (see fetchArticles.ts / fetchArticleDetail.ts); this file no longer holds mocks.

export interface Article {
  id: number;
  title: string;
  date: string;
  readTime: string;
  heroImage?: string | null;
  publishedAt?: string;   // raw ISO — used for the 3-day "NEW" badge
  isRead?: boolean;       // per-user (server) read state
}

const NEW_WINDOW_MS = 3 * 24 * 60 * 60 * 1000;

/** True while an article was published within the last 3 days. */
export const isArticleNew = (article: Article): boolean => {
  if (!article.publishedAt) return false;
  const published = new Date(article.publishedAt).getTime();
  return !Number.isNaN(published) && Date.now() - published < NEW_WINDOW_MS;
};

export interface ArticleDetail extends Article {
  content: string; // rich HTML body authored in the Django admin (Summernote)
  sourceUrl?: string;
}

export const ARTICLES_PAGE_PATH = '/articles';

export const ARTICLES_PER_PAGE_DESKTOP = 8;
export const ARTICLES_LOAD_BATCH_TOUCH = 10;

/** @deprecated Use ARTICLES_PER_PAGE_DESKTOP */
export const ARTICLES_PER_PAGE = ARTICLES_PER_PAGE_DESKTOP;
